export default __webpack_public_path__ + "static/media/how_entered_background.17d9342a.png";